import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g>
      <rect width="2" height="32" x="15" className="euiIcon__fillSecondary"/>
      <polygon points="0 32 13 32 13 30 2 30 2 2 13 2 13 0 0 0"/>
      <polygon points="19 0 19 2 30 2 30 30 19 30 19 32 32 32 32 0"/>
    </g>
  </svg>
);
